import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel'
import Tooltip from '@mui/material/Tooltip'

import { truncatedOptionLabel } from 'lib/Helper'
import { DEFAULT_CHAR_LIMIT } from 'lib/GlobalConstants'

export const ELLIPSIS_LENGTH = 3

export const CreateDeleteIcon = (showTooltip: boolean, tooltipText: string) => {
  const deleteIcon = <CancelIcon />

  if (showTooltip) {
    return (
      <Tooltip title={tooltipText} placement="bottom">
        {deleteIcon}
      </Tooltip>
    )
  }
  return deleteIcon
}

export const ChipLabel = (val: any, chipLabel: string) => {
  return (
    <>
      {truncatedOptionLabel(
        val?.[chipLabel] || val,
        DEFAULT_CHAR_LIMIT + ELLIPSIS_LENGTH,
      )}
    </>
  )
}
